import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const AlertTaskingPage = () => {
  return(
    <HomeUI />
  )
}

export default AlertTaskingPage;
